import React from 'react';
import './WhyChoose.css';

function WhyChoose() {
  const reasons = [
    {
      icon: '🎓',
      title: 'Expert-Guided Learning',
      description: 'Learn from experienced mentors through structured lessons designed for clarity, progress, and results.'
    },
    {
      icon: '🧭',
      title: 'Clear Learning Paths',
      description: 'Students follow focused learning journeys instead of scattered content, helping them stay consistent.'
    },
    {
      icon: '📱',
      title: 'Learn on Any Device',
      description: 'Access courses seamlessly across mobile, tablet, and desktop for uninterrupted learning anywhere.'
    },
    {
      icon: '💬',
      title: 'Responsive Student Support',
      description: 'Quick doubt resolution and learner support help students move forward without losing momentum.'
    },
    {
      icon: '📚',
      title: 'Practical Course Content',
      description: 'Each course is built to be useful, easy to follow, and aligned with real learning goals.'
    },
    {
      icon: '🚀',
      title: 'Built for Growth',
      description: 'A modern ed-tech experience that supports learners from their first lesson to long-term mastery.'
    }
  ];

  return (
    <section className="why-choose">
      <div className="container">
        <h2 className="section-title">
          Why Learners Choose <span className="highlight">Durbhasi Gurukulam</span><br />
          For Meaningful Digital Education
        </h2>
        
        <div className="reasons-grid">
          {reasons.map((reason, index) => (
            <div key={index} className="reason-card">
              <div className="reason-icon">{reason.icon}</div>
              <h3 className="reason-title">{reason.title}</h3>
              <p className="reason-description">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyChoose;
